





















import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  name: "RankDiff",
  props: {
    rank: {
      type: Number,
      default: 1
    },
    previousRank: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    const rankDiff = computed(() => {
      if (props.rank !== 0) return props.previousRank - props.rank;
      else return 0;
    });
    const diffState = computed(() => {
      const diff = props.previousRank - props.rank;
      if (props.rank === 0) return "outside";
      if (diff >= 1) return "up";
      else if (diff <= -1) return "down";
      return "even";
    });
    return {
      rankDiff,
      diffState
    };
  }
});
